import React from 'react'
import flatMap from 'lodash/flatMap'

import { Risk } from '@containers/Risk'
import { ParticipantFilter } from './ParticipantFilter'

export const JointRisk = ({ participantsQueries, config }) => {
  const [selectedParticipantId, setSelectedParticipantId] = React.useState(participantsQueries[0].participant.id)
  const selectedParticipantQuery = participantsQueries.find((participantQuery) => participantQuery.participant.id === selectedParticipantId)

  const riskProfile = selectedParticipantQuery
    ? selectedParticipantQuery.riskProfile.data.baseRiskProfile
    : flatMap(participantsQueries, (participantQuery) => participantQuery.riskProfile.data)

  return (
    <>
      <Risk
        filter={ () => (
          <ParticipantFilter
            filteredItemsName={'risk profile'}
            participantsQueries={participantsQueries}
            selectedParticipantId={selectedParticipantId}
            setSelectedParticipantId={setSelectedParticipantId}
          />
        )}
        riskProfile={riskProfile}
        crudActions={selectedParticipantQuery?.riskProfile.actions}

        tenant={config.tenant.slug}
        isRetired={selectedParticipantQuery?.scenario.data.baseScenario.isRetired}
        clientPronoun={config.userDetails.clientPronoun}
        inflation={selectedParticipantQuery?.scenario.data.baseScenario.assumptions.inflation}
        yearsToRetirement={selectedParticipantQuery?.scenario.data.baseScenario.yearsToRetirement}
        isWealthManager={config.userDetails.isWealthManager}
        useExternalRiskProfiling={false}
      />
    </>
  )
}
